import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Spin, Button, Result } from "antd";
import api, { tokenStorage } from "./http.js";

const RoleBasedRoute = ({ element, allowedRoles = [] }) => {
  const token = tokenStorage.getAccess();
  const navigate = useNavigate();

  const [userRole, setUserRole] = useState(() => localStorage.getItem("userRole"));
  const [loading, setLoading] = useState(() => !localStorage.getItem("userRole"));
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    let isMounted = true;
    const fetchRole = async () => {
      const cachedRole = localStorage.getItem("userRole");
      if (cachedRole) {
        if (isMounted) {
          setUserRole(cachedRole);
          setLoading(false);
        }
        return;
      }
      try {
        const response = await api.get("/authapp/api/v1/get_role/");
        const role = response?.data?.role;
        if (role) {
          tokenStorage.setRole(role);
          if (isMounted) setUserRole(role);
        }
      } catch (error) {
        if (isMounted) setIsError(true);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    if (token) {
      fetchRole();
    } else {
      setLoading(false);
    }

    return () => {
      isMounted = false;
    };
  }, [token]);

  if (!token) return <Navigate to="/signin" replace />;

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <Spin size="large" tip="Loading permissions..." />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] gap-4">
        <div className="text-rose-500 text-lg font-semibold">Failed to verify access</div>
        <p className="text-gray-500 text-sm">Unable to reach the server. Please check your connection.</p>
        <Button type="primary" onClick={() => window.location.reload()}>
          Retry
        </Button>
      </div>
    );
  }

  if (!userRole || !allowedRoles.includes(userRole)) {
    return (
      <div className="flex items-center justify-center min-h-[70vh] p-6">
        <Result
          status="403"
          title="403 - Access Denied"
          subTitle="Sorry, you do not have permission to access this page."
          extra={
            <Button type="primary" onClick={() => navigate("/signin")}>
              Sign In with Authorized Account
            </Button>
          }
        />
      </div>
    );
  }

  return element;
};

export default RoleBasedRoute;
